import React from "react";
import { Button } from "@/components/ui/button";
import { Loader2, Send } from "lucide-react";

interface Chat8PerguntasPanelFooterProps {
  isSubmitting: boolean;
  isSubmitButtonDisabled: boolean;
  onSubmit: () => void;
}

export const Chat8PerguntasPanelFooter: React.FC<Chat8PerguntasPanelFooterProps> = React.memo(
  ({ isSubmitting, isSubmitButtonDisabled, onSubmit }) => {
    return (
      <div className="p-4 border-t border-white/5 bg-navy-900/80 backdrop-blur-sm flex-shrink-0 rounded-b-lg">
        <div className="space-y-2">
          <Button
            onClick={onSubmit}
            disabled={isSubmitButtonDisabled}
            className={`w-full h-11 font-semibold ${!isSubmitButtonDisabled ? 'gradient-primary hover:shadow-blue-glow' : 'bg-navy-600/50'} transition-all`}
          >
            {isSubmitting ? (
              <>
                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                Enviando...
              </>
            ) : (
              <>
                <Send className="mr-2 h-4 w-4" />
                Enviar Respostas
              </>
            )}
          </Button>
        </div>
      </div>
    );
  }
);

Chat8PerguntasPanelFooter.displayName = "Chat8PerguntasPanelFooter"; 